/**
 * Flickity starts a drag on any pointer event inside a cell except form fields,
 * so native video controls need their events kept away from the carousel.
 */
(() => {
  const CAROUSEL_EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'click'];

  function keepEventOnVideo(event) {
    event.stopPropagation();
  }

  function guardVideo(video) {
    if (video.dataset.controlsGuard === 'true') {
      return;
    }

    video.dataset.controlsGuard = 'true';
    CAROUSEL_EVENTS.forEach((type) => video.addEventListener(type, keepEventOnVideo));
  }

  function guardMediaGallery(gallery) {
    gallery.querySelectorAll('video[controls]').forEach(guardVideo);
  }

  function observeMediaGallery(gallery) {
    if (gallery.dataset.videoControlsGuard === 'true') {
      return;
    }

    gallery.dataset.videoControlsGuard = 'true';
    guardMediaGallery(gallery);

    // Videos are cloned from a <template> only once playback starts.
    new MutationObserver(() => guardMediaGallery(gallery)).observe(gallery, {
      childList: true,
      subtree: true,
    });
  }

  function setup() {
    document.querySelectorAll('product-media').forEach(observeMediaGallery);
  }

  setup();
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();
